(function () {
  function initInfluencerComfort(sectionEl) {
    if (sectionEl.dataset.ifcInitialized === 'true') return;
    sectionEl.dataset.ifcInitialized = 'true';

    var scrollWrapper = sectionEl.querySelector('[data-ifc-scroll]');
    if (!scrollWrapper) return;

    scrollWrapper.setAttribute('tabindex', '0');
    var isDown = false;
    var startX;
    var scrollLeft;
    var hasMoved = false;

    scrollWrapper.addEventListener('mousedown', function (e) {
      if (e.target.closest('.ifc-play-btn')) return;
      isDown = true;
      hasMoved = false;
      startX = e.clientX;
      scrollLeft = scrollWrapper.scrollLeft;
      scrollWrapper.classList.add('ifc-dragging');
    });

    scrollWrapper.addEventListener('mouseleave', function () {
      if (isDown) {
        isDown = false;
        scrollWrapper.classList.remove('ifc-dragging');
      }
    });

    scrollWrapper.addEventListener('mouseup', function () {
      if (isDown) {
        isDown = false;
        scrollWrapper.classList.remove('ifc-dragging');
      }
    });

    scrollWrapper.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      hasMoved = true;
      var walk = (e.clientX - startX) * 1.2;
      scrollWrapper.scrollLeft = scrollLeft - walk;
    });

    scrollWrapper.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    var videos = sectionEl.querySelectorAll('[data-ifc-video]');
    var cards = sectionEl.querySelectorAll('[data-ifc-card]');
    var playBtns = sectionEl.querySelectorAll('[data-ifc-play]');
    var firstVideoLoaded = false;

    function setVideoSource(video) {
      var src = video.getAttribute('data-src');
      if (!src) return;
      var source = video.querySelector('source');
      if (source) {
        source.src = src;
      } else {
        var s = document.createElement('source');
        s.src = src;
        s.type = 'video/mp4';
        video.appendChild(s);
      }
      video.load();
    }

    function pauseAllExcept(videoEl) {
      videos.forEach(function (v) {
        if (v !== videoEl) {
          v.pause();
          v.currentTime = 0;
          var card = v.closest('[data-ifc-card]');
          if (card) {
            var btn = card.querySelector('[data-ifc-play]');
            if (btn) btn.classList.remove('ifc-playing');
          }
        }
      });
    }

    function playVideo(videoEl) {
      pauseAllExcept(videoEl);
      videoEl.play();
      var card = videoEl.closest('[data-ifc-card]');
      if (card) {
        var btn = card.querySelector('[data-ifc-play]');
        if (btn) btn.classList.add('ifc-playing');
      }
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var section = entry.target;
          io.unobserve(section);

          videos.forEach(function (video, index) {
            setVideoSource(video);

            video.addEventListener('play', function () {
              playVideo(video);
            });

            if (index === 0) {
              var muteAll = sectionEl.getAttribute('data-ifc-mute') === 'true';
              video.muted = muteAll;
              video.loop = true;
              video.play().catch(function () {});
              firstVideoLoaded = true;
              var card = video.closest('[data-ifc-card]');
              if (card) {
                var btn = card.querySelector('[data-ifc-play]');
                if (btn) btn.classList.add('ifc-playing');
              }
            }
          });
        });
      },
      { rootMargin: '50px', threshold: 0.1 }
    );

    io.observe(sectionEl);

    playBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (hasMoved) return;
        var card = btn.closest('[data-ifc-card]');
        if (!card) return;
        var video = card.querySelector('[data-ifc-video]');
        if (!video) return;
        if (video.readyState < 2) setVideoSource(video);
        var muteAll = sectionEl.getAttribute('data-ifc-mute') === 'true';
        video.muted = muteAll;
        video.loop = true;
        playVideo(video);

        var blockIndex = Number(card.getAttribute('data-block-index') || 0) + 1;
        if (typeof window.gaEvent === 'function') {
          window.gaEvent('short_video', [blockIndex, '', '', '', '', ''], false);
        }
      });
    });

    videos.forEach(function (video) {
      video.addEventListener('pause', function () {
        var card = video.closest('[data-ifc-card]');
        if (card) {
          var btn = card.querySelector('[data-ifc-play]');
          if (btn) btn.classList.remove('ifc-playing');
        }
      });
    });
    // Autoplay in mobile view when video is in viewport
     var isMobile = window.innerWidth < 768;
     if(isMobile) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Pause all other videos
              videos.forEach(video => {
                if (video !== entry.target) {
                  video.pause();
                }
              });
              // Play the one in view
              entry.target.play();
              console.log(entry.target);  
            } else {
              entry.target.pause();
            }
          });
        }, {
          root: scrollWrapper, // observe inside the scroll container
          threshold: 1 // 100% visible required
        });
        videos.forEach(video => observer.observe(video));
      }
    // 
  }

  document.querySelectorAll('.influencer-comfort-section').forEach(initInfluencerComfort);
  document.querySelectorAll('.what-matters-section').forEach(initInfluencerComfort);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.influencer-comfort-section');
      var section_mat = e.target.querySelector('.what-matters-section');
      if (section) initInfluencerComfort(section);
      if (section_mat) initInfluencerComfort(section_mat);
    });
  }
})();
